// @ts-check
import { LINE_HEIGHT } from 'common/constants/sizes';
import Text from 'components/base/Text';
import * as LighthouseService from 'common/services/lighthouse.service';
import { formatCypressTag } from 'common/utils/cypress.utils';
import HelpIcon from 'components/HelpIcon';

const Title = ({
  title,
  articleId,
  isHover,
  showHelp = true,
  showTotal = true,
  formattedDescription
}) => {
  const titleCyData = `${formatCypressTag(title)}-title`;

  return (
    <div
      className='flex h-10 flex-row items-center'
      data-testid='customWidget-title'
    >
      <Text
        textTransform='capitalize'
        data-cy={titleCyData}
        size='large'
        lineHeight={LINE_HEIGHT.large}
        multiLineEllipsisAfter={1}
      >
        {title}
      </Text>
      {isHover && articleId && showHelp && (
        <span className='ml-1'>
          <HelpIcon
            onClick={() => LighthouseService.navigateArticle(articleId)}
          />
        </span>
      )}
      {!showTotal && (
        <Text pl='0.5rem' mt='0.15rem' color='shuttleGray'>
          {formattedDescription}
        </Text>
      )}
    </div>
  );
};

export default Title;
